import { render, staticRenderFns } from "./kurzy.vue?vue&type=template&id=38580d53"
import script from "./kurzy.vue?vue&type=script&lang=js"
export * from "./kurzy.vue?vue&type=script&lang=js"
import style0 from "./kurzy.vue?vue&type=style&index=0&id=38580d53&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports